export const scrollBy = (x, y, smooth = true, element = window) => {
  try {
    element.scrollBy({
      top: y,
      left: x,
      behavior: smooth ? 'smooth' : null,
    });
  } catch (error) {
    element.scrollBy(x, y);
  }
};
